module.exports = __webpack_public_path__ + "img/eye-infinite-player.246a2f0f.png";